/* Trackgammon landing page (section: tg-landing). No dependencies. */
(function () {
  function init(root) {
    if (!root || root.dataset.tglReady) return;
    root.dataset.tglReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* 1. Viewfinder: running REC timecode; pause the clip for reduced motion */
    var tc = root.querySelector('[data-tgl-tc]');
    var vid = root.querySelector('[data-tgl-video]');
    if (vid) {
      if (reduce) { vid.removeAttribute('autoplay'); vid.pause(); }
      else { vid.playbackRate = 0.55; var p = vid.play && vid.play(); if (p && p.catch) p.catch(function () {}); }
    }
    if (tc && !reduce) {
      var secs = 0;
      setInterval(function () {
        secs++;
        var m = Math.floor(secs / 60) % 60, s = secs % 60, h = Math.floor(secs / 3600);
        tc.textContent = [h, m, s].map(function (x) { return String(x).padStart(2, '0'); }).join(':');
      }, 1000);
    }

    /* 1b. Hero film: click-to-play YouTube (privacy-enhanced). The link works without JS. */
    root.querySelectorAll('[data-tgl-yt]').forEach(function (a) {
      if (root.hasAttribute('data-tgl-noembed')) return; /* preview: open YouTube instead */
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + a.dataset.tglYt + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        f.title = a.getAttribute('aria-label') || 'Video';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        a.parentNode.replaceChild(f, a);
      });
    });

    /* 2. App buttons: send phones straight to their store */
    var ua = navigator.userAgent || '';
    root.querySelectorAll('[data-tgl-app]').forEach(function (a) {
      if (/iPhone|iPad|iPod/i.test(ua) && a.dataset.ios) a.href = a.dataset.ios;
      else if (/Android/i.test(ua) && a.dataset.android) a.href = a.dataset.android;
    });

    /* 3. Edit / Analysis tabs */
    root.querySelectorAll('[data-tgl-tabs]').forEach(function (group) {
      var tabs = group.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
            select(n); tabs[n].focus();
          }
        });
      });
      function select(n) {
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', j === n ? 'true' : 'false');
          t.tabIndex = j === n ? 0 : -1;
          var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = j !== n;
        });
      }
    });

    /* 4. Nova tiles: frame select + optional camera stand */
    root.querySelectorAll('[data-tgl-board]').forEach(function (card) {
      var json = card.querySelector('[data-tgl-variants]');
      var variants = json ? JSON.parse(json.textContent) : [];
      var select = card.querySelector('[data-tgl-frame]');
      var idInput = card.querySelector('[data-tgl-id]');
      var price = card.querySelector('[data-tgl-price]');
      var img = card.querySelector('[data-tgl-img]');
      var btn = card.querySelector('[data-tgl-add]');
      function update() {
        var v = variants.find(function (x) { return String(x.id) === select.value; });
        if (!v) return;
        idInput.value = v.id;
        if (price) price.innerHTML = v.p;
        if (img && v.img) { img.removeAttribute('srcset'); img.src = v.img; }
        btn.disabled = !v.a;
        btn.textContent = v.a ? btn.dataset.labelAdd : btn.dataset.labelSold;
      }
      if (select) select.addEventListener('change', update);
      var form = card.querySelector('form');
      if (form) form.addEventListener('submit', function (e) {
        var stand = card.querySelector('[data-tgl-with-stand]');
        if (!stand || !stand.checked || !window.fetch) return; /* plain POST adds the board alone */
        e.preventDefault();
        btn.disabled = true;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }, { id: Number(stand.value), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw r;
          window.location.href = base + 'cart';
        }).catch(function () { form.submit(); });
      });
    });
  }

  function boot() { document.querySelectorAll('[data-tgl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
